import { AlertTitle, Box, Typography } from "@mui/material";
import ErrorBox from "../../../../components/shared/boxes/ErrorBox";
import { useState } from "react";

const BasicDataMessageError = () => {
    const [open, setOpen] = useState(true);
    if (!open) return null;
    return (
        <Box sx={{ my: 2 }}>
            <ErrorBox
                errorMessage={
                    <>
                        <AlertTitle> Nenhuma atividade revisada encontrada para este cliente.</AlertTitle>
                        <Typography>
                            Para continuar, certifique-se de que pelo menos uma atividade foi revisada.
                            Caso necessário, selecione outro cliente na etapa anterior ou revise uma atividade
                            e tente novamente.
                        </Typography>
                    </>
                }
                onClose={() => setOpen(false)}
            />
        </Box>
    )
}

export default BasicDataMessageError;